angular
  .module("ticketco/ticketbuyer/common", [
    "ticketco/common",
    "angular-growl",
    "vcRecaptcha",
  ])
  .config([
    "tcMailgunProvider",
    "growlProvider",
    "vcRecaptchaServiceProvider",
    function(tcMailgunProvider, growlProvider, vcRecaptchaServiceProvider) {
      vcRecaptchaServiceProvider.setSiteKey(
        "6Lcy2SITAAAAAAMmXEQrH0-8RfSt-008SdlB7kV8"
      );
      growlProvider
        .globalTimeToLive({
          success: 3000,
          error: 5000,
          warning: 3000,
          info: 3000,
        })
        .globalDisableIcons(true)
        .globalPosition("top-center");
    },
  ]);
